module.exports = __webpack_public_path__ + "static/team-img3-be9c41a0fde4d79790cea9253a3f537b.jpg";